import { type Draft, produce } from 'immer';
import type { Reducer } from 'redux';
import { ActionTypes } from './actionTypes';
import type { RoutesAction } from './actions';

import type { UUID } from '@cobliteam/common-types';

import { type DeviceTrip, type NewRoute, type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

export interface RoutesState {
  updatedRouteWebData: WebData<NewRoute>;
  routeExecutionInfoWebData: WebData<DeviceTrip>;
  deletedRoutesWebData: WebData<UUID[]>;
  exportRoutesWebData: WebData<void>;
  exportedReportWebData: WebData<void>;
}

export const routesInitialState: RoutesState = {
  updatedRouteWebData: webDataNotAsked(),
  routeExecutionInfoWebData: webDataNotAsked(),
  deletedRoutesWebData: webDataNotAsked(),
  exportRoutesWebData: webDataNotAsked(),
  exportedReportWebData: webDataNotAsked(),
};

const routesReducer: Reducer<RoutesState, RoutesAction> = produce((draft: Draft<RoutesState>, action: RoutesAction) => {
  switch (action.type) {
    case ActionTypes.ROUTE_UPDATE_REQUEST:
      draft.updatedRouteWebData = webDataFetching();
      break;
    case ActionTypes.ROUTE_UPDATE_FAILED:
      draft.updatedRouteWebData = webDataError(action.payload);
      break;
    case ActionTypes.ROUTE_UPDATE_SUCCESS:
      draft.updatedRouteWebData = webDataSuccess(action.payload);
      break;
    case ActionTypes.ROUTE_EXECUTION_INFO_REQUEST:
      draft.routeExecutionInfoWebData = webDataFetching();
      break;
    case ActionTypes.ROUTE_EXECUTION_INFO_FAILED:
      draft.routeExecutionInfoWebData = webDataError();
      break;
    case ActionTypes.ROUTE_EXECUTION_INFO_SUCCEEDED:
      draft.routeExecutionInfoWebData = webDataSuccess(action.payload);
      break;
    case ActionTypes.ROUTES_DELETE_REQUEST:
      draft.deletedRoutesWebData = webDataFetching();
      break;
    case ActionTypes.ROUTES_DELETE_FAILED:
      draft.deletedRoutesWebData = webDataError();
      break;
    case ActionTypes.ROUTES_DELETE_SUCCESS:
      draft.deletedRoutesWebData = webDataSuccess(action.payload);
      break;
    case ActionTypes.EXPORT_ROUTES_REQUEST:
      draft.exportRoutesWebData = webDataFetching();
      break;
    case ActionTypes.EXPORT_ROUTES_FAILED:
      draft.exportRoutesWebData = webDataError();
      break;
    case ActionTypes.EXPORT_ROUTES_SUCCESS:
      draft.exportRoutesWebData = webDataSuccess(undefined);
      break;
    case ActionTypes.EXPORT_NEW_ROUTING_REPORT_REQUEST:
      draft.exportedReportWebData = webDataFetching();
      break;
    case ActionTypes.EXPORT_NEW_ROUTING_REPORT_FAILED:
      draft.exportedReportWebData = webDataError();
      break;
    case ActionTypes.EXPORT_NEW_ROUTING_REPORT_SUCCESS:
      draft.exportedReportWebData = webDataSuccess(undefined);
      break;
    default:
      break;
  }
}, routesInitialState);

export default routesReducer;
